<template>
  <div class="">
    <div class="row">
      <div class="col-12 col-md-5">
        <documents-send-mail-form
          :documentData="purchasesDelivery"
          :dispatchUrl="'purchasesDeliveries/sendMail'"
          :toggleMailModal="toggleMailModal"
          :mailInformation="mailInformation"
        />
      </div>
      <div
        class="col-12 col-md-7"
        style="max-height: 550px; overflow-y: scroll"
      >
        <purchases-delivery-view-details
          :showHeader="false"
          :purchasesDelivery="purchasesDelivery"
          @purchasesDeliveryItemsUpdated="get"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button type="danger" @click="toggleMailModal">
        {{ $t("COMMON.CANCEL") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { Button, Option, Select } from "element-ui";
import "flatpickr/dist/flatpickr.css";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import DocumentsSendMailForm from "@/components/DocumentsSendMailForm";
import PurchasesDeliveryViewDetails from "./PurchasesDeliveryViewDetails";

export default {
  layout: "DashboardLayout",
  name: "sales-delivery-mail-modal-content",

  components: {
    DocumentsSendMailForm,
    PurchasesDeliveryViewDetails,
    [Button.name]: Button,
  },

  mixins: [formMixin],
  props: {
    purchasesDelivery: {
      default: () => {},
    },
    toggleMailModal: {
      type: Function,
    },
    get: {
      type: Function,
    },
    loading: {
      default: () => true,
    },
  },

  data() {
    return {
      submitting: false,
      mailInformation: {
        organization: {},
        recipient: {},
        user: {},
      },
    };
  },

  created() {},

  mounted() {
    this.mailInformation = {
      organization: this.purchasesDelivery?.organization,
      subject: this.$t("COMMON.EMAIL_INFOS_SUBJECT_DELIVERY", {
        organization: this.purchasesDelivery?.organization?.name,
        code: this.purchasesDelivery.code,
      }),
      recipient: {
        username: this.purchasesDelivery?.issuer?.customer_name,
        email: this.purchasesDelivery?.issuer?.email,
      },
    };
  },

  methods: {},

  watch: {
    purchasesDelivery(purchasesDelivery) {
      this.mailInformation = {
        organization: purchasesDelivery.organization,
        subject: this.$t("COMMON.EMAIL_INFOS_SUBJECT_DELIVERY", {
          organization: purchasesDelivery.organization?.name,
          code: purchasesDelivery.code,
        }),
        recipient: {
          username: purchasesDelivery?.issuer?.customer_name,
          email: purchasesDelivery?.issuer?.email,
        },
      };
    },
  },
};
</script>
